import prop from "lodash/fp/prop";
import { createSelector } from "reselect";

export const selectSelectedSegment = createSelector(
  prop("spotShipmentPage"),
  prop("selectedSegment")
);
